// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"resellers-module--itemTitle--1Plzv","fontsLoading":"resellers-module--fonts-loading--1i_V3"};